import jsonFile from './story-instructions.json';

class Progress {
  static getInstance() {
    if (!Progress.instance) {
      Progress.instance = new Progress();
    }
    return Progress.instance;
  }

  constructor() {
    this.progress;
    this.progress = {
      body: 1,
      bodyCompleted: false,
      shop: 1,
      shopCompleted: false,
      myZoombiesNfts: 1,
      myZoombiesNftsCompleted: false,
      valuation: 1,
      valuationCompleted: false,
      cardSets: 1,
      cardSetsCompleted: false,
      affiliates: 1,
      affiliatesCompleted: false
    };
    this.storageKey = 'progress';
    this.homePath = 'friends';
  }

  getProgress() {
    let prog = window.localStorage.getItem(this.storageKey);
    if (prog) {
      prog = JSON.parse(prog);
      if (prog !== this.progress) {
        this.progress = prog;
      }
      return this.progress;
    } else {
      if (!this.progress) {
        const arr = Object.keys(jsonFile);
        const defaultProgress = arr.reduce((acc, curr) => ((acc[curr] = 1), acc), {});
        this.progress = defaultProgress;
        return this.progress;
      }
      return this.progress;
    }
  }

  updateProgress(newProg) {
    let prog = this.progress;

    if (!this.progress) {
      prog = this.getProgress();
    }

    prog[newProg.name] = newProg.value;
    this.progress = prog;
    window.localStorage.setItem(this.storageKey, JSON.stringify(prog));
  }
  // Function call looks like: xyz.updateProgress({name: 'comp1', value: 1});

  resetProgress() {
    window.localStorage.removeItem(this.storageKey);
    this.progress = {
      body: 1,
      bodyCompleted: false,
      shop: 1,
      shopCompleted: false,
      myZoombiesNfts: 1,
      myZoombiesNftsCompleted: false,
      valuation: 1,
      valuationCompleted: false,
      cardSets: 1,
      cardSetsCompleted: false,
      affiliates: 1,
      affiliatesCompleted: false
    }
    this.updateProgress(this.progress);
  }

  getCurrentPath() {
    let path = window.location.pathname;
    let i = path.lastIndexOf('/');
    if (i == path.length - 1) {
      return '';
    }
    return path.substring(i + 1);
  }
  
  isPathComplete(path) {
    switch(path) {
      case "BodyContent":
        path = 'body'
        break;
      case 'ShopContent':
        path = 'shop'
        break;
      case 'CryptContent':
        path = 'myZoombiesNfts'
        break;
      case 'TokenContent':
        path = 'valuation'
        break;
      case 'CardSets':
        path = 'cardSets'
        break;
      case 'AffiliateDashboard':
        path = 'affiliates'
        break; 
    }
    let prog = this.getProgress();
    let check = path + 'Completed';
    if (prog[check]) {
      return true;
    }
    return false;
  }
    // isPathComplete(path) {
  //   let prog = this.getProgress();
  //   let storyCount = Object.keys(jsonFile[path]).length;
  //   if (storyCount && prog.path > storyCount) {
  //     return true;
  //   }
  //   return false;
  // }
}

export default Progress;